export const SELECT_CLINIC = "clinic/SELECT_CLINIC";

export const GET_ALL_CLINIC_REQUEST = "clinic/GET_ALL_CLINIC_REQUEST";
export const GET_ALL_CLINIC_SUCCESS = "clinic/GET_ALL_CLINIC_SUCCESS";
export const GET_ALL_CLINIC_FAILURE = "clinic/GET_ALL_CLINIC_FAILURE";

export const GET_DETAIL_CLINIC_BY_DATE_REQUEST =
  "clinic/GET_DETAIL_CLINIC_BY_DATE_REQUEST";
export const GET_DETAIL_CLINIC_BY_DATE_SUCCESS =
  "clinic/GET_DETAIL_CLINIC_BY_DATE_SUCCESS";
export const GET_DETAIL_CLINIC_BY_DATE_FAILURE =
  "clinic/GET_DETAIL_CLINIC_BY_DATE_FAILURE";

export const CLINIC_FORM_CREATE_FIELD_REQUEST =
  "CLINIC_FORM_CREATE_FIELD_REQUEST";
export const CLINIC_FORM_CREATE_FIELD_REQUEST_SUCCESS =
  "CLINIC_FORM_CREATE_FIELD_REQUEST_SUCCESS";
export const CLINIC_FORM_CREATE_FIELD_REQUEST_FAIL =
  "CLINIC_FORM_CREATE_FIELD_REQUEST_FAIL";
export const UPLOAD_FILE_CLINIC = "UPLOAD_FILE_CLINIC";
export const RESET_CLINIC_FORM = "RESET_CLINIC_FORM";
export const CLINIC_FORM_SUCCESS = "CLINIC_FORM_SUCCESS";

export const SHOW_LOADING = "clinic/SHOW_LOADING";
export const HIDE_LOADING = "clinic/HIDE_LOADING";
export const CLINIC_FORM_SAVE_FIELD = "clinic/CLINIC_FORM_SAVE_FIELD";
